import React from 'react';
import MenuLink from './MenuLink';
import css from './Dropdowns.module.scss';
import { useStaticQuery, graphql } from 'gatsby';
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews';

const DropdownResources = ({ setActiveDropdown }) => {
  const staticData = useStaticQuery(graphql`
    query HeaderResourcesDropdownQuery {
      prismicHeader {
        _previewable
        data {
          resources_body {
            ... on PrismicHeaderDataResourcesBodyNavbarDropdownLinkGroup {
              id
              primary {
                title
              }
              items {
                subtitle
                title
                link {
                  url
                  target
                }
                icon {
                  url
                  gatsbyImageData(width: 20, height: 20, placeholder: NONE)
                  alt
                }
              }
            }
          }
          resources_left_links {
            title
            subtitle
            link {
              url
              target
            }
            icon {
              url
              gatsbyImageData(width: 20, height: 20, placeholder: NONE)
              alt
            }
          }
          resources_left_title
        }
      }
    }
  `);
  const {
    prismicHeader: { data },
  } = useMergePrismicPreviewData(staticData);

  return (
    <div className={css.megamenu}>
      <div className={css.leftMenu}>
        <h2>{data.resources_left_title}</h2>
        {data.resources_left_links.map(item => {
          return (
            <MenuLink
              setActiveDropdown={setActiveDropdown}
              title={item.title}
              desc={item.subtitle}
              url={item.link?.url || '#'}
              targetBlank={item.link.target}
              icon={item.icon}
            />
          );
        })}
      </div>
      <div className={css.rightMenu}>
        {data.resources_body.map(group => {
          return (
            <>
              <h2>{group.primary.title}</h2>
              {group.items.map(item => {
                return (
                  <MenuLink
                    setActiveDropdown={setActiveDropdown}
                    title={item.title}
                    desc={item.subtitle}
                    url={item.link?.url || '#'}
                    targetBlank={item.link.target}
                    icon={item.icon}
                  />
                );
              })}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default DropdownResources;
